import Badge from "react-bootstrap/Badge";

interface Props {
  /**
   * The checked value. True renders the flagged (red) badge and false renders the
   * compliant (green) badge, which makes it visible that the check was performed.
   */
  flagged: boolean
  flaggedLabel: string
  compliantLabel: string
}

const ComplianceBadge = ({flagged, flaggedLabel, compliantLabel}: Props) => {
  return flagged
    ? <Badge bg={"danger"}>{flaggedLabel}</Badge>
    : <Badge bg={"success"}>{compliantLabel}</Badge>
}

export default ComplianceBadge
